import axios from 'axios';
import { sendErrorAnalytics } from '../../catalog/Analytics';
import { isValidString } from '../../catalog/Validity';

const apiKey = 'AIzaSyAWA1vSfe7CQ29uMP3F223nID2RhgMvYQw';

export const getYoutubeUploadsAPI = async (channelId: string, setState: Function) => {
    try {
        if (!isValidString(channelId)) {
            return;
        }
        const channelResponse = await axios({ method: 'get',
            url: 'https://www.googleapis.com/youtube/v3/channels',
            params: {
                part: 'contentDetails',
                id: channelId,
                key: apiKey,
            } });

        const playlistId = channelResponse.data.items[0].contentDetails.relatedPlaylists.uploads;

        const playlistResponse = await axios({ method: 'get',
            url: 'https://www.googleapis.com/youtube/v3/playlistItems',
            params: {
                part: 'snippet',
                maxResults: 50,
                key: apiKey,
                playlistId,
                order: 'date',
            } });

        setState({ type: 'setVideos',
            videos: playlistResponse.data.items.map((item: any) => {
                return `https://youtube.com/watch?v=${item.snippet.resourceId.videoId}`;
            }) });
    } catch (error) {
        sendErrorAnalytics('Error loading youtube videos');
        setState({ type: 'setVideos', videos: [] });
    }
};

export const getYoutubeUploadsBetterAPI = async (channelId: string, setState: Function) => {
    try {
        if (!isValidString(channelId)) {
            return;
        }
        const playlistId = `${channelId.substring(0, 1)}U${channelId.substring(2)}`;

        const playlistResponse = await axios({ method: 'get',
            url: 'https://www.googleapis.com/youtube/v3/playlistItems',
            params: {
                part: 'snippet',
                maxResults: 12,
                key: apiKey,
                playlistId,
                order: 'date',
            } });

        setState({ type: 'setVideos',
            videos: playlistResponse.data.items.map((item: any) => {
                return { title: item.snippet.title, url: `https://youtube.com/watch?v=${item.snippet.resourceId.videoId}` };
            }) });
    } catch (error) {
        sendErrorAnalytics('Error loading youtube videos');
        setState({ type: 'setVideos', videos: [] });
    }
};
